import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { usePriorityDistribution } from '../../hooks/useDashboard';
import { PRIORITY_LABELS } from '@maios/shared';
import Spinner from '../ui/Spinner';

const PRIORITY_COLORS: Record<string, string> = {
  BLOCKER: '#000000',
  CRITICAL: '#DC2626',
  HIGH: '#F87171',
  MEDIUM: '#FBBF24',
  LOW: '#60A5FA',
};

const PRIORITY_ORDER = ['BLOCKER', 'CRITICAL', 'HIGH', 'MEDIUM', 'LOW'];

interface Props {
  projectId: string;
}

export default function PriorityBarWidget({ projectId }: Props) {
  const { data, isLoading } = usePriorityDistribution(projectId);

  if (isLoading) {
    return <div className="flex items-center justify-center h-full"><Spinner className="size-6" /></div>;
  }

  const sorted = PRIORITY_ORDER
    .map((p) => ({
      priority: p,
      name: PRIORITY_LABELS[p] ?? p,
      count: data?.find((d) => d.priority === p)?.count ?? 0,
    }))
    .filter((d) => d.count > 0);

  return (
    <div className="h-full flex flex-col">
      <h3 className="text-sm font-semibold text-gray-700 mb-2">우선순위별 작업</h3>
      {sorted.length === 0 ? (
        <div className="flex-1 flex items-center justify-center text-sm text-gray-400">데이터 없음</div>
      ) : (
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={sorted} layout="vertical" margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
            <XAxis type="number" tick={{ fontSize: 11 }} stroke="#9CA3AF" allowDecimals={false} />
            <YAxis type="category" dataKey="name" tick={{ fontSize: 11 }} stroke="#9CA3AF" width={50} />
            <Tooltip
              contentStyle={{ fontSize: 12, borderRadius: 8 }}
              formatter={(value) => [`${value}건`]}
            />
            <Bar dataKey="count" radius={[0, 4, 4, 0]} maxBarSize={28}>
              {sorted.map((entry) => (
                <Cell key={entry.priority} fill={PRIORITY_COLORS[entry.priority] ?? '#D1D5DB'} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
